export interface HealthyHomesSearch {
  property?: number;
}

export function parseHealthyHomesSearch(search: Record<string, unknown>): HealthyHomesSearch {
  const value = search.property;
  const property =
    typeof value === 'number'
      ? value
      : typeof value === 'string' && /^\d+$/.test(value)
        ? Number(value)
        : NaN;
  return Number.isSafeInteger(property) && property > 0 ? { property } : {};
}
